import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => {
  return 'artifact_trigger_' + (Math.floor(Math.random() * 90000000) + 10000).toString();
};

const initData = () => ({
  outputKey: keyAuto(),
  artifactDefinitionId: '',
  eventNames: [],
});

const onLoadData = (data) => ({
  outputKey: data?.outputKey || keyAuto(),
  artifactDefinitionId: data?.artifactDefinitionId || '',
  eventNames: data?.eventNames || [],
});

const { getStore: getTriggerOnArtifactStore, defaultStore } = createComponentStore({
  type: 'trigger_on_artifact',
  endpoint: 'trigger_on_artifact',
  registryKey: 'trigger_on_artifact',
  initData,
  onLoadData,
});

export { getTriggerOnArtifactStore, defaultStore };
export default defaultStore;
